export const IMPRESSION_TYPE = {
  IMPRESSION: '0',
  START: '1',
  FIRST_QUARTILE: '25',
  MIDPOINT: '50',
  THIRD_QUARTILE: '75',
  COMPLETE: '100',
  DISPLAY_PRE: 'PRE',
  DISPLAY_POST: 'POST',
  CLICK: 'CLICK',
};

export const AD_TYPE = {
  MREC: 'MREC',
  OVERLAY: 'OVERLAY',
  VPAID: 'VPAID',
  VAST: 'VAST',
  IMA: 'IMA',
  TAPPX_PREBID: 'TAPPX_PREBID',
  PREBID: 'PREBID',
  VIDEO_DIRECTO: 'VIDEODIRECTO',
  VIDEO_INSTREAM: 'VIDEO_INSTREAM',
  VIDEO_OUTSTREAM: 'VIDEO_OUTSTREAM',
  VIDEO_MREC: 'VIDEO_MREC',
};

export const EVENT_STATUS = {
  ERROR: 'ERROR',
  REQUEST: 'REQUEST',
  DELIVERY: 'DELIVERY',
  DELIVERY_WINNER: 'DELIVERY_WINNER',
  DELIVERY_EMPTY: 'DELIVERY_EMPTY', // TENER ENCUENTA ESTE FACTOR
  CROSS: 'CROSS', // ???
  BAD_REQUEST: 'BAD_REQUEST',
  IMPRESSION: 'IMPRESSION',
  WINNER_EMPTY: 'WINNER_EMPTY',
  PLAYER_LOADED: 'PLAYER_LOADED',
  VIEWABILITY: 'VIEWABILITY',
  REQUEST_PUBLISHER: 'REQUEST_PUBLISHER',
  REQUEST_DEMAND: 'REQUEST_DEMAND',
  CONTENT_VIEW: 'CONTENT_VIEW',
};

export const ENDPOINTS = {
  ERROR: '/errors',
  REQUEST: '',
  REQUEST_PUBLISHER: '/request-publisher',
  REQUEST_DEMAND: '/request-demand',
  DELIVERY: '/delivery',
  DELIVERY_WINNER: '/delivery',
  DELIVERY_EMPTY: '/delivery',
  BAD_REQUEST: '',
  IMPRESSION: '/impression',
  WINNER_EMPTY: '/delivery',
  PLAYER_LOADED: '/player-load',
  VIEWABILITY: '',
  CONTENT_VIEW: '/content-view',
};

export const TYPECONTENT = {
  PLAYER: 'PLAYER',
  AD: 'AD',
  CONTENT: 'CONTENT',
  FRONTAL: 'FRONTAL',
};
export const STATUS_FRQ = [
  { statusCode: ['400'], timeRange: '5_200', perc: { inTime: 100, outTime: 100 } },
  { statusCode: ['200'], timeRange: '5_400', perc: { inTime: 100, outTime: 100 } },
  { statusCode: ['204'], timeRange: '5_400', perc: { inTime: 100, outTime: 100 } },
  {
    statusCode: [
      '300',
      '301',
      '302',
      '303',
      '304',
      '305',
      '306',
      '307',
      '308',
      '401',
      '402',
      '403',
      '404',
      '405',
      '406',
      '407',
      '409',
      '410',
      '411',
      '412',
      '413',
      '414',
      '415',
      '416',
      '417',
      '418',
      '420',
      '422',
      '423',
      '424',
      '425',
      '426',
      '428',
      '429',
      '431',
      '444',
      '449',
      '450',
      '451',
      '499',
    ],
    timeRange: '',
    perc: { inTime: 100 },
  },
  {
    statusCode: [
      '500',
      '501',
      '502',
      '503',
      '504',
      '505',
      '506',
      '507',
      '508',
      '509',
      '510',
      '511',
      '598',
      '599',
      '408',
    ],
    timeRange: '',
    perc: { inTime: 100 },
  },
  { statusCode: 'no_status', timeRange: '', perc: { inTime: 100 } },
];
export const VERSION = 2;
export const TRACKING_CONSUMER = 'client-monitoring';
export const CONSUMER_BASE_URL = 'https://ext.track.tappx.com';
export const CONN_TYPE = 'JSTag';
export const AD_TYPES = {
  mrec: ['300x250'],
  banner: ['728x90', '300x50', '320x50'],
  video: ['9x9', '6x6'],
  interstitial: ['320x480', '480x320', '768x1024', '1024x768'],
};
export const ID_MSG = 1;
